module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "golf-reservation"
  }, [_c('div', {
    staticClass: "reservation-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('label', {
    staticClass: "field club-field"
  }, [_c('span', [_vm._v("Golf club")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedClub),
      expression: "selectedClub"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedClub = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clubs), function(club) {
    return _c('option', {
      key: club
    }, [_vm._v(_vm._s(club))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "field schedule-mode"
  }, [_c('span', [_vm._v("Schedule mode")]), _vm._v(" "), _c('div', {
    staticClass: "mode-options"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleMode),
      expression: "scheduleMode"
    }],
    attrs: {
      "type": "radio",
      "value": "normal"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleMode, "normal")
    },
    on: {
      "change": function($event) {
        _vm.scheduleMode = "normal"
      }
    }
  }), _vm._v(" Normal")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduleMode),
      expression: "scheduleMode"
    }],
    attrs: {
      "type": "radio",
      "value": "simple"
    },
    domProps: {
      "checked": _vm._q(_vm.scheduleMode, "simple")
    },
    on: {
      "change": function($event) {
        _vm.scheduleMode = "simple"
      }
    }
  }), _vm._v(" Simple")])])]), _vm._v(" "), _c('label', {
    staticClass: "field date-field"
  }, [_c('span', [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "date-control"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Previous day"
    },
    on: {
      "click": function($event) {
        _vm.moveDate(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-chevron-left"
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDate),
      expression: "selectedDate"
    }],
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.selectedDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectedDate = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "aria-label": "Next day"
    },
    on: {
      "click": function($event) {
        _vm.moveDate(1)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-chevron-right"
  })])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tabs-actions"
  }, [_c('div', {
    staticClass: "tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('button', {
    class: {
      active: _vm.activeTab === 'calendar'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'calendar'
      }
    }
  }, [_vm._v("Calendar")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.activeTab === 'reservation'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'reservation'
      }
    }
  }, [_vm._v("Regular Reservation")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.activeTab === 'groupReservation'
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.activeTab = 'groupReservation'
      }
    }
  }, [_vm._v("Group Reservation")])]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.moveDate(-1)
      }
    }
  }, [_c('i', {
    staticClass: "icon ion-arrow-left-c"
  }), _vm._v(" Previous")]), _vm._v(" "), _c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addTeeTime
    }
  }, [_c('i', {
    staticClass: "icon ion-plus-round"
  }), _vm._v(" Add tee time")]), _vm._v(" "), _c('button', {
    staticClass: "btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.moveDate(1)
      }
    }
  }, [_vm._v("Next "), _c('i', {
    staticClass: "icon ion-arrow-right-c"
  })])])]), _vm._v(" "), (_vm.activeTab === 'calendar') ? _c('div', {
    staticClass: "schedule-wrap"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "schedule-table"
  }, [_c('div', {
    staticClass: "schedule-head"
  }, [_c('span', [_vm._v("Time")]), _vm._v(" "), _vm._l((_vm.teeBoxes), function(teeBox) {
    return _c('span', {
      key: teeBox
    }, [_vm._v(_vm._s(teeBox))])
  })], 2), _vm._v(" "), _vm._l((_vm.slots), function(slot) {
    return _c('div', {
      key: slot.time,
      staticClass: "schedule-row"
    }, [_c('div', {
      staticClass: "time-cell"
    }, [_vm._v("\n            " + _vm._s(slot.time) + "\n            "), _c('small', [_vm._v(_vm._s(slot.period))])]), _vm._v(" "), _vm._l((_vm.teeBoxes), function(teeBox) {
      return _c('div', {
        key: teeBox,
        staticClass: "booking-cell"
      }, _vm._l((_vm.playerSlots), function(playerIndex) {
        return _c('button', {
          key: playerIndex,
          staticClass: "player-cell",
          class: _vm.bookingClass(slot.bookings[teeBox] && slot.bookings[teeBox][playerIndex]),
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              _vm.selectBooking(slot, teeBox, playerIndex)
            },
            "contextmenu": function($event) {
              $event.preventDefault();
              $event.stopPropagation();
              _vm.openPlayerMenu(slot, teeBox, playerIndex, $event)
            }
          }
        }, [(slot.bookings[teeBox] && slot.bookings[teeBox][playerIndex]) ? [_c('strong', [_vm._v(_vm._s(slot.bookings[teeBox][playerIndex].name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(slot.bookings[teeBox][playerIndex].member))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(slot.bookings[teeBox][playerIndex].status))])] : [_c('i', {
          staticClass: "icon ion-plus"
        }), _vm._v(" "), _c('span', [_vm._v("Player " + _vm._s(playerIndex + 1))])]], 2)
      }))
    })], 2)
  })], 2)]) : (_vm.activeTab === 'groupReservation') ? _c('group-reservation', {
    attrs: {
      "golf-club": _vm.selectedClub,
      "booking-date": _vm.selectedDate
    },
    on: {
      "back": function($event) {
        _vm.activeTab = 'calendar'
      }
    }
  }) : _c('regular-reservation', {
    attrs: {
      "golf-club": _vm.selectedClub,
      "booking-date": _vm.selectedDate,
      "reservation": _vm.selectedReservation,
      "selected-player": _vm.selectedPlayer
    },
    on: {
      "back": function($event) {
        _vm.activeTab = 'calendar'
      },
      "remove-player": _vm.removeSelectedPlayer
    }
  }), _vm._v(" "), (_vm.playerMenu.visible) ? _c('div', {
    staticClass: "player-context-menu",
    style: ({
      left: _vm.playerMenu.x + 'px',
      top: _vm.playerMenu.y + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handlePlayerMenuAction('view')
      }
    }
  }, [_vm._v(_vm._s(_vm.contextPlayer ? 'View player' : 'Add player'))]), _vm._v(" "), (_vm.contextPlayer) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handlePlayerMenuAction('edit')
      }
    }
  }, [_vm._v("Edit reservation")]) : _vm._e(), _vm._v(" "), (_vm.contextPlayer) ? _c('button', {
    staticClass: "danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.handlePlayerMenuAction('remove')
      }
    }
  }, [_vm._v("Remove player")]) : _vm._e()]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('div', [_c('p', {
    staticClass: "eyebrow"
  }, [_vm._v("GOLF OPERATIONS")]), _vm._v(" "), _c('h2', [_vm._v("Golf Reservation")])]), _vm._v(" "), _c('div', {
    staticClass: "reservation-status"
  }, [_c('span', {
    staticClass: "status-dot"
  }), _vm._v("\n        Live schedule\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice"
  }, [_c('i', {
    staticClass: "icon ion-information-circled"
  }), _vm._v(" Tee time availability is updated as reservations are confirmed.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule-legend"
  }, [_c('span', [_c('i', {
    staticClass: "legend reserved"
  }), _vm._v(" Reserved")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "legend checkin"
  }), _vm._v(" Check in")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "legend checkout"
  }), _vm._v(" Check out")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "legend available"
  }), _vm._v(" Available")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd42b52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Golf/GolfReservation.vue
// module id = 791
// module chunks = 1